/**
 * Baut den service-qualifizierten Event-Namen, wie er seit v0.77.14 auf dem
 * Draht steht: `<service>.<resource>.<action>`
 * (z.B. `mednet-identity.profile.updated`).
 *
 * ⚠️ Der SSE-Hub schreibt BENANNTE Events (`event: <EventKey>`), und
 * `liveBus.track({ eventName })` matcht den Namen exakt. Ein unqualifizierter
 * Name (`profile.updated`) feuert deshalb nie — ohne Fehlermeldung.
 *
 * Reiner String-Baustein: keine Abhaengigkeit, kein Register. Der Konsument
 * nennt Service, Ressource und Aktion seines Produzenten; die Komponente tippt
 * den Namen nicht von Hand.
 */
export function qualifiedEventKey(
  service: string,
  resource: string,
  action: string,
): string {
  for (const [label, part] of [
    ["service", service],
    ["resource", resource],
    ["action", action],
  ] as const) {
    if (part === "" || part.includes(".")) {
      throw new Error(
        `qualifiedEventKey: ${label} must be non-empty and contain no ".": ${JSON.stringify(part)}`,
      );
    }
  }
  return `${service}.${resource}.${action}`;
}

/**
 * Default live event of `<pfs-notification-bell>` / `<pfs-notification-inbox>`:
 * pfs-notifications' realtime adapter emits the fact `delivery.pushed`
 * (user-targeted via `Keys.external_user_id`). Until v0.77.12 this was a
 * hand-sent `notification.created`; that key is now the Writer's own event of a
 * new notification row and is NOT unicast to the user. Overridable per
 * `data-event-name`.
 */
export const NOTIFICATION_PUSHED_EVENT = qualifiedEventKey(
  "pfs-notifications",
  "delivery",
  "pushed",
);
